var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke: #00b0a9;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #00b0a9;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10504",
    "data-name": "Group 10504",
    transform: "translate(-593.5 -774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10503",
    "data-name": "Group 10503",
    transform: "translate(-172.125 507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    className: "cls-1",
    d: "M222.245,35.125h-.453c-2.567,0-4.667,2.459-4.667,5.464s2.1,5.464,4.667,5.464h10.667c2.567,0,4.667-2.459,4.667-5.464s-2.1-5.464-4.667-5.464h-.453",
    transform: "translate(549 239.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    className: "cls-1",
    d: "M224.912,39.125h-.453a3.663,3.663,0,0,0-3.333,3.9,3.663,3.663,0,0,0,3.333,3.9h10.667a3.663,3.663,0,0,0,3.333-3.9,3.663,3.663,0,0,0-3.333-3.9h-.453",
    transform: "translate(546.28 237.357)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10496",
    "data-name": "Group 10496",
    transform: "translate(772.392 268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7012",
    "data-name": "Path 7012",
    className: "cls-1",
    d: "M236.485,30.125h-1.027c-.2,0-.333.158-.333.394v2.552c0,.236.133.394.333.394h6.853c.2,0,.333-.158.333-.394V30.519c0-.236-.133-.394-.333-.394h-1.027",
    transform: "translate(-235.125 -24.616)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1749",
    "data-name": "Ellipse 1749",
    className: "cls-2",
    cx: 1.493,
    cy: 1.493,
    r: 1.493,
    transform: "translate(2.24 4.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7013",
    "data-name": "Path 7013",
    className: "cls-1",
    d: "M241.8,24.6a1.992,1.992,0,0,1,1.4-.6,1.862,1.862,0,0,1,1.4.6",
    transform: "translate(-239.453 -21.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7014",
    "data-name": "Path 7014",
    className: "cls-1",
    d: "M238.9,20.971a3.37,3.37,0,0,1,4.733,0",
    transform: "translate(-237.62 -18.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7015",
    "data-name": "Path 7015",
    className: "cls-1",
    d: "M236.1,17.373a4.653,4.653,0,0,1,6.6,0",
    transform: "translate(-235.673 -16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10497",
    "data-name": "Group 10497",
    transform: "translate(773.566 280.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7387",
    "data-name": "Path 7387",
    className: "cls-3",
    d: "M1.024,3.125H0",
    transform: "translate(2.047 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7388",
    "data-name": "Path 7388",
    className: "cls-3",
    d: "M1.024,3.125H0",
    transform: "translate(4.095 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7386",
    "data-name": "Path 7386",
    className: "cls-3",
    d: "M1.024,3.125H0",
    transform: "translate(0 -3.125)"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3094",
    "data-name": "Rectangle 3094",
    className: "cls-4",
    width: 20,
    height: 20,
    transform: "translate(594 774)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDevices);
export default __webpack_public_path__ + "static/media/totalDevices.8418015083e0772a0fce1df9a1731b1e.svg";
export { ForwardRef as ReactComponent };